import { render, staticRenderFns } from "./ItemSearch.vue?vue&type=template&id=cf637c8c"
import script from "./ItemSearch.vue?vue&type=script&lang=js"
export * from "./ItemSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/89/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf637c8c')) {
      api.createRecord('cf637c8c', component.options)
    } else {
      api.reload('cf637c8c', component.options)
    }
    module.hot.accept("./ItemSearch.vue?vue&type=template&id=cf637c8c", function () {
      api.rerender('cf637c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/ItemSearch.vue"
export default component.exports